/** Small constructors + guards so parsers build IR without object-literal noise. */
import type {
  IriTerm,
  LiteralTerm,
  QueryIR,
  Term,
  TriplePattern,
  VarTerm,
} from "./types.ts";

export const XSD_INTEGER = "http://www.w3.org/2001/XMLSchema#integer";

export function v(name: string): VarTerm {
  return { kind: "var", name };
}

export function iri(value: string, label?: string): IriTerm {
  return label === undefined ? { kind: "iri", value } : { kind: "iri", value, label };
}

export function lit(
  value: string,
  opts?: { datatype?: string; language?: string },
): LiteralTerm {
  const t: LiteralTerm = { kind: "literal", value };
  if (opts?.datatype !== undefined) t.datatype = opts.datatype;
  if (opts?.language !== undefined) t.language = opts.language;
  return t;
}

export function triple(
  subject: Term,
  predicate: Term,
  object: Term,
  extra?: { optional?: boolean; sourceIds?: string[] },
): TriplePattern {
  const p: TriplePattern = { subject, predicate, object };
  if (extra?.optional !== undefined) p.optional = extra.optional;
  if (extra?.sourceIds !== undefined) p.sourceIds = extra.sourceIds;
  return p;
}

export function isIri(t: Term): t is IriTerm {
  return t.kind === "iri";
}

export function isVar(t: Term): t is VarTerm {
  return t.kind === "var";
}

/** Every distinct IRI mentioned anywhere in the IR (for the Explain panel). */
export function iriTerms(ir: QueryIR): IriTerm[] {
  const seen = new Map<string, IriTerm>();
  for (const p of ir.patterns) {
    for (const term of [p.subject, p.predicate, p.object]) {
      if (term.kind === "iri" && !seen.has(term.value)) seen.set(term.value, term);
    }
  }
  return [...seen.values()];
}
